import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { ActionButton, Button, DocumentCard, DocumentCardActions, DocumentCardActivity, DocumentCardLocation, DocumentCardPreview, DocumentCardTitle, Dropdown, IDropdownOption, Icon, IconButton, Panel, PanelType, PrimaryButton, Text, Toggle, TooltipHost } from "office-ui-fabric-react";
import { ulid } from 'ulid';
import { NavLink, Route, Switch, useHistory, useLocation, useParams } from "react-router-dom";
import moment from 'moment-timezone';

import { apiGet, apiPost } from "../../../helpers-sales";

import { WsDeliverJobInterface, WsDeliverTenantInterface } from "../../../../../core/src/interfaces";

import { getTimestamp } from "./ConfigPage";

import { Loading } from "../../Shared";

import { WsDeliverPortalContext } from "../DeliverPortalContext";
import { sanitize, wait } from "../../../helpers";

import { WsTimestamp } from "../../DateTime/Timestamp";
import { getJobStatus, getJobTitle } from "../data/deliver-data";


import '../Config/Demo.scss';

import './ConfigPage.scss';
import './ConfigTenant.scss';

import './JobPanel.scss';






const WsJobsPage = (props: {}) => {

  const portalContext = useContext(WsDeliverPortalContext);

  const [ jobList, setJobList ] = useState<WsDeliverJobInterface[] | undefined>(undefined);



  const loadJobData = async (clearState: boolean) => {

    if (clearState) {
      setJobList(undefined);
    }

    const result = await apiGet(`/deliver/jobs`);

    if (result && Array.isArray(result.jobs)) {
      const resultData = result.jobs as WsDeliverJobInterface[];
      setJobList(resultData);
    }

    await wait(20000);

    loadJobData(false);
  };

  useEffect(() => {
    loadJobData(false);
  }, []);



  if (jobList) {



    // class list

    const classList = [ 'ws-deliver-jobs-page ws-deliver-tenant-list' ];

    // if ([ 'new' ].includes(params.workload || '')) {
    //   classList.push('ws-deliver-normalization-new');
    // }



    // render

    return (
      <div className={classList.join(' ')}>

        <div className="ws-deliver-config-header">
          <Text key={'ws-sales-clients'} variant={'xLarge'} nowrap block>
            {`Configuration Jobs`}
          </Text>
        </div>

        <table className="table is-bordered is-hoverable is-fullwidth ws-job-list">
          <thead>
            <tr>
              <th>Tenant</th>
              <th>Action</th>
              <th>Progress</th>
              <th>Status</th>
              <th>Started</th>
              <th>Duration</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              jobList.map((jobItem: WsDeliverJobInterface, jobIndex) => {

                const durationMinutes = jobItem.data.status === 'COMPLETE' ? moment.duration(moment(jobItem.modifiedAt).diff(moment(jobItem.createdAt))).asMinutes() : moment.duration(moment().diff(moment(jobItem.createdAt))).asMinutes();

                return (
                  <tr key={`ws-deliver-job-${jobItem.id}`}>
                    <td>{jobItem.tenant.name}</td>
                    <td>{jobItem.data.action}</td>
                    <td>{(jobItem.data.progress * 100).toFixed(0)}%</td>
                    <td>
                      {
                        jobItem.data.status === 'COMPLETE'
                        ?
                        <><div className="Toastify__toast-icon Toastify--animate-icon Toastify__zoom-enter"><svg viewBox="0 0 24 24" width="100%" height="100%" fill="var(--toastify-icon-color-success)"><path d="M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"></path></svg></div></>
                        :
                        <><div className="Toastify__toast-icon"><div className="Toastify__spinner"></div></div></>
                      }
                      {getJobStatus(jobItem)}
                    </td>
                    <td>{ jobItem.createdAt && <WsTimestamp timestamp={jobItem.createdAt} /> }</td>
                    <td>
                      {
                        durationMinutes < 1
                        ?
                        <>less than a minute</>
                        :
                        <>
                          {durationMinutes.toFixed(0)} {durationMinutes % 10 === 1 && durationMinutes % 100 !== 11 ? 'minute' : 'minutes'}
                        </>
                      }
                    </td>
                    <td><IconButton iconProps={{ iconName: 'MultiSelect' }} title="Details" onClick={() => {
                      portalContext?.setJobPanelVisible(jobItem.id || 0);
                    }} /></td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    );

  } else {
    return (<Loading />);
  }
};





const WsJobPanel = (props: {
  jobId: number;
  closePanel: () => void;
}) => {

  const portalContext = useContext(WsDeliverPortalContext);

  const isMounted = useRef(true);

  const [ jobItem, setJobItem ] = useState<WsDeliverJobInterface | undefined>(undefined);


  const [ outputLog, setOutputLog ] = useState<string>('');

  const [ errorLog, setErrorLog ] = useState<string>('');
  


  // unmount

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);



  // data

  const loadJobData = async () => {

    setJobItem(undefined);
    setOutputLog('');
    setErrorLog('');

    const result = await apiGet(`/deliver/job-status/${props.jobId}`);

    if (result && result.jobItem && isMounted.current) {
      const resultData = result.jobItem as WsDeliverJobInterface;
      setJobItem(resultData);

      setOutputLog(result.outputLog || '');
      setErrorLog(result.errorLog   || '');

    } else {
      // console.log('not mounted!');
    }
  };

  useEffect(() => {
    loadJobData();
  }, [ props.jobId ]);



  // socket wsp:job

  useEffect(() => {

    const socketData = async (data: any) => {

      if (data && data.trace && data.jobItem) {

        if (data.jobItem.id === props.jobId && isMounted.current) {
          setJobItem(data.jobItem);
          setOutputLog(data.outputLog || '');
          setErrorLog(data.errorLog   || '');
        }
      }
    };

    portalContext?.socketClient.on('wsp:job', socketData);

    return () => {
      portalContext?.socketClient.off('wsp:job', socketData);
    };

  }, [ props.jobId ]);




  const [ selectedView, setSelectedView ] = useState<string>('OUTPUT');


  const getLogList = (log: string) => {

    const logSplit = log.split('**********************');

    // console.log(logSplit);

    if (logSplit.length > 2) {

      const logCombine = [ logSplit[2] ];

      const logHeader = logSplit[1];

      const logHeaderFilter = logHeader.split('\r\n').filter((line) => line.indexOf('Host Application') < 0 && line.indexOf('Windows PowerShell transcript start') < 0);

      // console.log(logHeaderFilter);

      logCombine.unshift(logHeaderFilter.join('\r\n'));

      return logCombine.join('');

    } else if (logSplit.length === 2) {

      return '';

    } else {
      return '';
    }
  };



  getLogList(outputLog);



  const filterLog = [
    'Transcript started, output file is C:\\DSC.log'
  ];



  return (
    <Panel
      customWidth="750px"
      isBlocking={false}
      isOpen={true}
      onDismiss={() => {
        props.closePanel();
      }}
      type={PanelType.custom}
    >
      {
        jobItem
        ?
        <div className="ws-deliver-job-panel">
          <h2 className="title is-4">{jobItem ? getJobTitle(jobItem): ''}</h2>

          <div>
            <b>Status:</b> {jobItem ? getJobStatus(jobItem) : ''}
          </div>

          <br />

          <div>

            <div className="tabs is-toggle is-small" style={{ marginTop: 5, marginBottom: 5 }}>
              <ul>
                <li className={ selectedView === 'OUTPUT' ? 'is-active' : '' }>
                  <a onClick={() => {
                    setSelectedView('OUTPUT');
                  }}>
                    <span>Log</span>
                  </a>
                </li>
                <li className={ selectedView === 'ERRORS' ? 'is-active' : '' }>
                  <a onClick={() => {
                    setSelectedView('ERRORS');
                  }}>
                    <span>Errors</span>
                  </a>
                </li>
              </ul>
            </div>

          </div>

          <div className="ws-deliver-job-panel-log ws-scroll ws-scroll-y">
            {getLogList( selectedView === 'OUTPUT' ? outputLog : errorLog ).split('\r\n').map((item, key) => {
              if (item && !filterLog.includes(item)) {
                return <div className="ws-deliver-job-panel-log-line" key={key} dangerouslySetInnerHTML={sanitize(`<div>${key}</div>${item}`, {})} />;
              } else {
                return null;
              }
            })}
            <br />
            <br />
          </div>
        </div>
        :
        <Loading />
      }
    </Panel>
  );
};




export {
  WsJobsPage,
  WsJobPanel
};
